import React  from 'react'
import { 
	Route, 
	Switch,
	Redirect
} from 'react-router-dom'
import { RouterToUrlQuery } from 'react-url-query';
import { ConnectedRouter } from 'connected-react-router'

import {
	AccountContainer,
	Dashboard,

	CandidateContainer,
	CandidateListContainer,

	ConsultantContainer,
	ConsultantListContainer,

	ClientContainer,
	ClientListContainer,
	
	JobContainer,
	JobListContainer,

	createNotesContainer,

	TimesheetContainer,
	TimesheetListContainer,
	
	Login,
	Logout,
	ForgotPassword,
	ResetPassword,
	Register,
	Welcome,
	
	NotFound,
} from '@scenes'

import history from './history';
import App from '@scenes/App/App'
import PrivateRoute from '@components/PrivateRoute'
import PublicRoute from '@components/PublicRoute'

export default (
	<ConnectedRouter history={history}>
		<RouterToUrlQuery>
			<div>
				<Switch>

					<PublicRoute exact path='/' render={({loggedIn}) => <Redirect to={loggedIn ? "/dashboard" : "/welcome"} />} />
		      <PublicRoute path='/welcome' component={Welcome} />
		      <PublicRoute path='/login' component={Login} />
		      <PublicRoute path='/register' component={Register} redirectLoggedInUsers={false} />
		      <PublicRoute path='/forgot-password' component={ForgotPassword} />
		      <PublicRoute path='/reset-password/:token' component={ResetPassword} />
		      
			    <App>
			    	<Switch>
				    	<Route
				    		path="/dashboard"
				    		component={Dashboard} 
				    	/>
				    	<PrivateRoute 
				    		path="/candidates" 
				    		component={CandidateListContainer} 
				    		permissions={['readOwn:candidate']} 
				    	/>
				    	<PrivateRoute 
				    		exact
				    		path="/candidate/:id" 
				    		component={CandidateContainer} 
				    		permissions={['readOwn:candidate']}
				    	/>
				    	<PrivateRoute 
				    		path="/candidate/:id/notes" 
				    		component={createNotesContainer('candidate')}
				    		permissions={['readAny:note']}
				    	/>
				    	<PrivateRoute 
				    		path="/clients" 
				    		component={ClientListContainer} 
				    		permissions={['readOwn:client']}
				    	/>
				    	<PrivateRoute 
				    		exact
				    		path="/client/:id" 
				    		component={ClientContainer} 
				    		permissions={['readOwn:client']}
				    	/>
				    	<PrivateRoute 
				    		path="/client/:id/notes" 
				    		component={createNotesContainer('client')} 
				    		permissions={['readAny:note']}
				    	/>
				    	<PrivateRoute 
				    		path="/admins" 
				    		component={ConsultantListContainer} 
				    		permissions={['readAny:admin']}
				    	/>
				    	<PrivateRoute 
				    		exact
				    		path="/admin/:id" 
				    		component={ConsultantContainer}
				    		permissions={['readAny:admin']}
				    	/>
				    	<PrivateRoute 
				    		path="/jobs" 
				    		component={JobListContainer} 
				    		permissions={['readOwn:job']}
				    	/>
				    	<PrivateRoute 
				    		path="/job/:id" 
				    		component={JobContainer} 
				    		permissions={['readOwn:job']}
				    	/>
				    	<PrivateRoute 
				    		path="/timesheets" 
				    		component={TimesheetListContainer} 
				    		permissions={['readOwn:timesheet']}
				    	/>
				    	<PrivateRoute 
				    		path="/timesheet/:id" 
				    		component={TimesheetContainer} 
				    		permissions={['readOwn:timesheet']}
				    	/>
				    	<PrivateRoute 
				    		path="/account" 
				    		component={AccountContainer} 
				    	/>
				    	<PrivateRoute 
				    		path="/logout" 
				    		component={Logout} 
				    	/>
				    	<PrivateRoute component={NotFound} />
				    </Switch>
			    </App>

		    </Switch>
		  </div>
	  </RouterToUrlQuery>
	</ConnectedRouter>
)


// WEBPACK FOOTER //
// ./src/routes.js